import { render } from "./ClientGeneralInformationTab.vue?vue&type=template&id=d6c138f0&scoped=true"
import script from "./ClientGeneralInformationTab.vue?vue&type=script&lang=js"
export * from "./ClientGeneralInformationTab.vue?vue&type=script&lang=js"

import "./ClientGeneralInformationTab.vue?vue&type=style&index=0&id=d6c138f0&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c138f0"]])

export default __exports__